    <div class="preview_container" *ngIf="detailsImport$ | async as detailsImport">
        <div class="table_products">
            <div class="header_preview">
                <h2>{{ detailsImport.preview.products.length}} {{"Catalogs.products_included"|translate}}</h2>
            </div>
            <div class="page_container">
                <table class="listing_table preview">
                    <thead class="header_stiky">
                        <tr class="head_preview">
                            <th>{{"common.image"|translate}}</th>
                            <th>{{"common.name"|translate}} <br> {{"inventory.sku"|translate}}</th>
                            <th>{{"common.description"|translate}}</th>
                            <th class="number_clmn">{{"inventory.stock"|translate}}</th>
                            <th>{{"brands.brands"|translate}}</th>
                            <th>{{"import.category_import"|translate}}</th>
                            <th class="number_clmn">{{"import.cost"|translate}} </th>
                            <th class="number_clmn">{{"Catalogs.retail_price"|translate}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let product of detailsImport.preview.products">
                            <tr class="body_preview hover_tr">
                                <td class="first_td">
                                    <img class="listing_image" [src]="product[getFieldIndex(detailsImport.matches.fields, detailsImport.matches.columns, 'image_1920')] || 'assets/icones/no-image.png'" alt="">
                                </td>
                                <td class="td_block cursor">
                                    <span class="bold_span">{{ product[getFieldIndex(detailsImport.matches.fields, detailsImport.matches.columns,'name')] }}</span><br>
                                    <span class="light_span">{{ product[getFieldIndex(detailsImport.matches.fields, detailsImport.matches.columns,'sku')] }}</span>
                                </td>
                                <td class="td_actions description_cell">
                                    <span class="descr_elemnt" [innerHTML]="product[getFieldIndex(detailsImport.matches.fields, detailsImport.matches.columns,'description')]">
                                    </span>
                                </td>
                                <td class="number_clmn">
                                    {{ product[getFieldIndex(detailsImport.matches.fields, detailsImport.matches.columns,'product_variant_ids/stock_id/quantity')] }}
                                </td>
                                <td>
                                    {{ product[getFieldIndex(detailsImport.matches.fields, detailsImport.matches.columns,'brand_id')] ?? 'N/A' }}
                                </td>
                                <td>
                                    {{ product[getFieldIndex(detailsImport.matches.fields, detailsImport.matches.columns,'category_ids')] ?? 'N/A' }}
                                </td>
                                <td class="number_clmn">{{ product[getFieldIndex(detailsImport.matches.fields, detailsImport.matches.columns,'standard_price')]}}</td>
                                <td class="number_clmn">
                                    {{ product[getFieldIndex(detailsImport.matches.fields, detailsImport.matches.columns,'list_price')] }}
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="foter_buttons btns_commit">
            <button class="save_btn_pop_up cancel_btn_pop_up" (click)="back()">
                <span> {{"common.back"|translate | uppercase}}</span>
                <img alt="" src="../../../../../assets/icones/arrow_back.svg">
            </button>
            <button class="save_btn_pop_up green_btn" *ngIf="!detailsImport.committed" (click)="commit(detailsImport)">
                <span> {{"common.commit"|translate}}</span>
                <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
            </button>
        </div>
    </div>
